import React from 'react';
import { Button, Tooltip, Tag, } from 'antd';

import CustomTable from '../../../components/CustomTable';

export default function ResultList(props) {
    return (
        <CustomTable
            loadingExcel={props.loadingExcel}
            loadingPdf={props.loadingPdf}
            loadingPrint={props.loadingPrint}
            onExportExcel={props.onExportExcel}
            onExportPdf={props.onExportPdf}
            onPrint={props.onPrint}
            onChange={props.onChange}
            pagination={props.pagination}
            rowKey={record => record.id}
            columns={[
                {
                    title: 'Opciones',
                    width: "100px",
                    key: 'options',
                    align: 'center',
                    render: (value, row) => (
                        <div className="custom-options">
                            <Tooltip placement="top" title={"Editar"}>
                                <Button
                                    type="primary"
                                    icon="edit"
                                    size={"small"}
                                    onClick={() => props.onEdit(row)}
                                />
                            </Tooltip>
                        </div>
                    )
                },
                {
                    title: 'Nombre',
                    dataIndex: 'nombre',
                    key: 'nombre',
                    sorter: true
                },
                {
                    title: 'Código Sunat',
                    dataIndex: 'codigoSunat',
                    key: 'codigoSunat',
                    sorter: true
                }
            ]}
        />
    );
}